import React from 'react';
import ContentBox from './ContentBox';
import {
  getFirestore, collection, query, orderBy, limit, onSnapshot, doc
} from 'firebase/firestore';

const normalizeHandle = (h) => (!h ? '@unknown' : h.startsWith('@') ? h : `@${h}`);
const formatMoney = (n = 0) =>
  Number(n).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// “7 minutes ago”
function timeAgo(ms) {
  if (!ms) return 'just now';
  const secs = Math.floor((Date.now() - ms) / 1000);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const steps = [
    ['year', 31536000], ['month', 2592000], ['week', 604800],
    ['day', 86400], ['hour', 3600], ['minute', 60]
  ];
  for (const [unit, s] of steps) if (secs >= s) return rtf.format(-Math.floor(secs / s), unit);
  return 'just now';
}

export default function Archive() {

  const [rows, setRows] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const listRef = React.useRef(null);

  React.useEffect(() => {
    const db = getFirestore();

    // Oldest → Newest so newest is at the bottom
    const q = query(
      collection(db, 'submissions'),           // or 'public_feed'
      orderBy('createdAt', 'asc'),
      limit(500)
    );

    const unsubFeed = onSnapshot(q, (snap) => {
      const items = snap.docs.map((d) => {
        const x = d.data();
        return {
          id: d.id,
          handle: normalizeHandle(x.handle),
          amount: Number(x.amountCents ?? x.amount ?? 0), // change to /100 if you store cents
          createdAtMs: x.createdAt?.toMillis?.() ?? 0,
        };
      });
      setRows(items);

      // auto-scroll to bottom so newest is visible
      requestAnimationFrame(() => {
        if (listRef.current) listRef.current.scrollTop = listRef.current.scrollHeight;
      });
    });

    const unsubTotal = onSnapshot(doc(db, 'stats', 'global'), (snap) => {
      const data = snap.data() || {};
      setTotal(Number(data.total ?? data.totalCents ?? 0)); // adjust to /100 if using cents
    });

    return () => { unsubFeed(); unsubTotal(); };
  }, []);

  const fmt = (v) => formatMoney(v); // change to v/100 if needed
  
  return (
    <ContentBox>
      <div className="contents-main">
        <div className="submissions__feed" ref={listRef}>
          {rows.length === 0 ? (
            <div className="submission submission--empty"><p>No submissions yet.</p></div>
          ) : rows.map((r) => (
            <div className="submission" key={r.id}>
              <div className="submission__line">
                <span className="submission__handle"><b>{r.handle}</b></span>
                <span className="submission__verb"> Invoiced Meta for</span>
                <span className="submission__amount"> <b>{fmt(r.amount)}</b></span>
              </div>
              <div className="submission__meta">{timeAgo(r.createdAtMs)}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="contents-footer">
        <p className="footer-label">Total Invoiced</p>
        <p className="footer-value">{fmt(total)}</p>
      </div>
    </ContentBox>
  );
}
